import {FC} from 'react';
import style from './style.module.scss';
import Link from 'components/CustomRoutingLink';
import {TTypographyVariant, Typography} from 'components/Typography';
import {IPhoneNumber} from 'modules/wineshops-list/models';
import {formatToPhoneMask} from 'core/regex';

interface IProps {
    phone?: IPhoneNumber;
    variant?: TTypographyVariant;
}

export const WineShopPhone: FC<IProps> = ({phone, variant = 'label-16-r'}) => {
    const {number, additionalPhone} = phone || {};
    const formattedPhone = formatToPhoneMask(number);

    if (additionalPhone) {
        return (
            <div className={style.linkWrapper}>
                <Link className={style.link} href={`tel:${number}`}>
                    <Typography
                        itemProp={'telephone'}
                        variant={variant}
                    >{`${formattedPhone} доб. ${additionalPhone}`}</Typography>
                </Link>
            </div>
        );
    }

    return number ? (
        <div className={style.linkWrapper}>
            <Link className={style.link} href={`tel:${number}`}>
                <Typography itemProp={'telephone'} variant={variant}>
                    {formattedPhone}
                </Typography>
            </Link>
        </div>
    ) : null;
};
